<template>
  <div class="row">
    <div class="col-12 testimonios">
      <div style="display: block; position: relative; left: 37px; top: 49px;">
        <img src="@/assets/testimonial/quote.svg">
      </div>
      <swiper class="swiper" :options="swiperOption" ref="testimonialsCarousel">
        <swiper-slide>
          <div class="testimonial-body">
            <div>
              Sin tener vida crediticia ni documentos colombianos, Ábaco creyó en mí y me abrió las puertas para adquirir créditos... Hoy ya llevo más de 5 créditos con ábaco.
            </div>
            <div style="display: inline-block">
              <div>
                <img src="">
              </div>
              <div>
               <span class="testimonial-name">Deivy Lucena</span><br>
               <img src="@/assets/testimonial/logo-rappi-new.svg" width="30%">
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="testimonial-body">
            <div>
              Con Ábaco pude adquirir desde repuestos para mi moto, soat, libre inversión  hasta para la licencia de conducción... poco a poco fui ascendiendo en los montos de credito.
            </div>
            <div style="display: inline-block">
              <div>
                <img src="">
              </div>
              <div>
               <span class="testimonial-name">Jose Mata</span><br>
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="testimonial-body">
            <div>
              Sin importar si estoy reportado o no Ábaco  me dio la oportunidad de demostrarles mi buen comportamiento de pago.
            </div>
            <div style="display: inline-block">
              <div>
                <img src="">
              </div>
              <div>
               <span class="testimonial-name">Manolo Caballero</span><br>
               <img src="@/assets/testimonial/logo-rappi-new.svg" width="30%">
              </div>
            </div>
          </div>
        </swiper-slide>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
  import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
  import 'swiper/swiper.min.css'
  export default {
    name: 'Testimonials',
    title: 'Ábaco testimonials',
    components: {
      Swiper,
      SwiperSlide
    },
    data() {
      return {
        swiperOption: {
          slidesPerView: 1,
          centeredSlides: true,
          spaceBetween: 50,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        }
      }
    },
    methods: {
      toSlide(index) {
        this.$refs.testimonialsCarousel.$swiper.slideTo(index, 0)
      }
    }
  }
</script>

<style>
.testimonios {
  background-color: #FBF3EC;
  margin-top: 69px;
  margin-bottom: 55px;
}
.testimonial-body {
  position: relative;
  display: block;
  left: auto;
  width: 75%;
  margin-left: 60px;
  margin-right: 60px;
  padding-bottom: 55px;
  font-size: 1.2rem;
}
.testimonial-name {
  height: 27px;
  width: 136px;
  color: #333333;
  font-family: "Source Serif Pro";
  font-size: 22px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Testimonials.vue